import ClosuresStore from '~/client/src/shared/stores/domain/Closures.store'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

export interface ILocationClosureContext {
  closuresStore: ClosuresStore
  projectDateStore: ProjectDateStore
  selectedStartDate?: Date
  selectedEndDate?: Date
  shouldHideRestrictions?: boolean
}

interface IClosableObject {
  id: string
}

export function isLocationClosed(
  dataObject: IClosableObject,
  {
    closuresStore,
    projectDateStore,
    selectedStartDate,
    selectedEndDate,
    shouldHideRestrictions,
  }: ILocationClosureContext,
): boolean {
  // Text boxes and lines carry no dataObject, and every displayed item reaches here —
  // not just the ones drawing an icon, as when this lived in the DOM marker.
  if (shouldHideRestrictions || !dataObject || !closuresStore) {
    return false
  }

  const isNowWithinSelectedInterval = projectDateStore.isWithinDateInterval(
    selectedStartDate,
    selectedEndDate,
    new Date(),
  )

  return isNowWithinSelectedInterval
    ? !closuresStore.isLocationNowOpen(dataObject.id)
    : closuresStore.isLocationClosedForEntirePeriod(
        dataObject.id,
        selectedStartDate,
        selectedEndDate,
      )
}

export function isLocationPartiallyClosed(
  dataObject: IClosableObject,
  {
    closuresStore,
    selectedStartDate,
    selectedEndDate,
    shouldHideRestrictions,
  }: ILocationClosureContext,
): boolean {
  if (shouldHideRestrictions) {
    return false
  }

  return (
    dataObject &&
    closuresStore &&
    closuresStore.isLocationHasPartialClosuresWithinSelectedRange(
      dataObject.id,
      selectedStartDate,
      selectedEndDate,
    )
  )
}
